<template>
  <div>
    <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div id="addOrEdit" style="overflow:hidden;height:100%">
      <div style="float:left;width:30%;border:1px solid #e9e9e9;border-bottom:1px solid transparent;overflow-y: auto"
           :style="screenHeight">
        <div v-for="(option,indexOne) in fileData" :key="indexOne"
             style="margin-top:12px;margin-left:5px;margin-right:5px;">
          <div>
            <p style="width:100%;border:1px solid #bbd9fb;"></p>
            <p style="z-index:2;margin-top:-10px;margin-left:10px;background:white;width: max-content;">&ensp;
              <span style="width: 100px;overflow: hidden;">{{option.groupName}}</span>
              <img @click="showOrHideGroup(indexOne)" v-if="'1' == showHideList[indexOne]"
                   src="@/assets/image/workOrder/closeIcon.png"/>
              <img @click="showOrHideGroup(indexOne)" v-if="'0' == showHideList[indexOne]"
                   src="@/assets/image/workOrder/Openicon.png"/>
              &ensp;</p>
          </div>
          <div style="padding:10px 25px 25px 25px">
            <div style="position:relative;">
              <Form ref="addEditColumn" v-if="'1' == showHideList[indexOne]" label-colon class="form_submit_pop"
                    :show-message="false"
                    :model="fileData.fieldList" :rules="ruleValidate">
                <FormItem :label="item.customName" :prop="item.customColName" :title="item.customName" v-if="('add'==addOrEdit && item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime'
        && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status' && item.customColName!='orderTheme' && item.customColName!='orderDescribe') || ('edit'==addOrEdit && item.customColName!='orderTheme' && item.customColName!='orderDescribe')"
                          v-for="(item,index) in option.allColumnInfo"
                          :key="index" :class="{'formDefinedClass':item.type=='file' || item.type=='textarea'}">
<!--                  <a v-show="!editCopyId" href="javascript:void(0);" @click="handleOpen('2')"><p-->
<!--                    style="color:#fdc06d;position:absolute;top:0px;right:0px"-->
<!--                    v-if="item.customColName=='copyEmpId' && showCopy">抄送给我</p></a>-->
<!--                  <a v-show="!editCopyId" href="javascript:void(0);" @click="handleOpen('3')"><p-->
<!--                    style="color:#fdc06d;position:absolute;top:0px;right:0px"-->
<!--                    v-if="item.customColName=='copyEmpId' && !showCopy && !editTable">移出我</p></a>-->

                  <Input v-if="item.type=='text' && item.customColName!='customerName'" :readonly="item.customColName=='customerPhone'" v-model="item.popCustomValue"
                         :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"/>

                  <Input v-if="item.customColName=='customerName'" v-model="item.popCustomValue" readonly
                         @on-focus="getCustomerInfo" :disabled="editTable && 'edit' == addOrEdit"/>

                  <Input v-if="item.type=='textarea'" type="textarea" :rows="3" v-model="item.popCustomValue"
                         :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"/>

                  <DatePicker type="datetime" v-if="item.type=='datetime'" :confirm="true"
                              :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit"
                              format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"
                              @on-change="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"
                              v-model="item.popCustomValue"></DatePicker>
                  <Select
                    v-if="(item.type=='select' || item.type=='radio') && item.customColName!='customerName' && item.customColName!='orderHandler'"
                    ref="clearSingleSelect"
                    :clearable="item.customIsSystem != '1'" v-model="item.popCustomValue"
                    @on-change="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"
                    :disabled="( editTable) && 'edit' == addOrEdit">
                    <Option v-for="(option, index) in item.list" :value="option.id" :key="index" :disabled="option.isClose == '0'">{{option.dictValue}}
                    </Option>
                  </Select>

                  <el-select v-if="item.customColName=='orderHandler'"
                          ref="clearSingleSelect" filterable
                          :clearable="item.customIsSystem != '1'" v-model="item.popCustomValue"
                          @change="editOrderHandler($event,item,indexOne,index)"
                          :disabled="(item.customIsAlter!='1' || editHandle) && 'edit' == addOrEdit">
                    <el-option-group label="工单服务组">
                      <el-option v-for="(option, index) in item.list[0].serviceGroup" :label="option.dictValue" :value="option.id" :key="index"></el-option>
                    </el-option-group>
                    <el-option-group label="员工">
                      <el-option v-for="(option, index) in item.list[0].employeeGroup" :label="option.dictValue" :value="option.id" :key="index"></el-option>
                    </el-option-group>
                  </el-select>

                  <Select v-if="item.type=='checkbox' && item.customColName!='copyEmpId'" :clearable="item.customIsSystem != '1'" multiple
                          :max-tag-count="2" @on-change="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"
                          v-model="item.popCustomValue" :disabled="(editTable) && 'edit' == addOrEdit" ref="clearSingleSelect">
                    <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                    </Option>
                  </Select>

                  <Select v-if="item.customColName=='copyEmpId'" :clearable="item.customIsSystem != '1'" multiple filterable
                          :max-tag-count="2" @on-change="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"
                          v-model="item.popCustomValue" :disabled="(item.customIsAlter!='1' || editCopyId) && 'edit' == addOrEdit" ref="clearSingleSelect">
                    <OptionGroup label="工单服务组">
                      <Option v-for="(option, index) in item.list[0].serviceGroup" :value="option.id" :key="index">{{option.dictValue}}</Option>
                    </OptionGroup>
                    <OptionGroup label="员工">
                      <Option v-for="(option, index) in item.list[0].employeeGroup" :value="option.id" :key="index">{{option.dictValue}}</Option>
                    </OptionGroup>
                  </Select>

                  <el-cascader v-if="item.type=='cascade'" v-model="item.popCustomValue" :placeholder="item.customName"
                               ref="clearSingleSelect" @change="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"
                               :clearable="item.customIsSystem == '1'" :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit"
                               :title="item.customName"
                               :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

                  <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.popCustomValue"
                         :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','allWorkOrder')"/>

                  <File v-if="item.type=='file'" @fileUploadCallback="fileUploadCallback" :editTable="editTable" :addOrEdit="addOrEdit" v-model="item.popCustomValue" :showFilelist="true"
                        @changeFile="changeFile(item,indexOne,index)"/>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <a style="display: none;" href="javascript:void(0)" id='hiddenPop'></a>
      <div v-if="'add' == addOrEdit" style="float:right;width:68%;box-shadow: 3px 3px 10px #9c9c9c;"
           :style="screenHeight">
        <div style="padding-top:15px;padding-left:4%">
          <div>
            <p style="color:#298bee;display:inline-block;margin-right:15px"><span style="color: red">*</span>{{orderTheme.customName}}:</p>
            <Input v-model="orderTheme.popCustomValue" :placeholder="'输入工单'+orderTheme.customName"
                   style="display:inline-block;width:85%"/>
          </div>
          <div style="display:flex;align-items: flex-start;margin-top:20px">
            <p style="color:#298bee;margin-right:17px"><span style="color: red">*</span>{{orderDescribe.customName}}:</p>
            <div style="width:85%">
              <div style="background-color:#eeeeee;width:100%;padding:5px 0 5px 15px;">
                <Checkbox style="color:#a1a1a1;margin-right:20px" v-model="isSecret">私密回复</Checkbox>
                <Poptip placement="top" transfer>
                  <img src="@/assets/image/workOrder/Expressicon.png"/>
                  <div slot="content">
                    <div v-for="(item, index) in emojiList" :key="index">
                      <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr"
                           @click="clickHandler(emotion)"/>
                    </div>
                  </div>
                  <span style="color: #a1a1a1;margin-right:20px;font-size:14px">表情</span>
                </Poptip>
                <Upload :action="baseUploadUrl" :on-error="uploadFail" :max-size="15360"
                        :before-upload="handleBeforeUpload" :on-success="(res,file)=>onSuccess(res,file)"
                        :on-exceeded-size="handleMaxSize" :show-upload-list="showUploadList"
                        style="display:inline-block">

                  <img src="@/assets/image/workOrder/Uploadicon.png"/>
                  <span style="color: #a1a1a1;font-size:14px">上传附件</span>
                </Upload>
              </div>
              <p class="edittext" contenteditable="true" ref="editDiv"
                 style="border: 1px solid #dae2fb;margin-top:0px;padding: 4px 7px;" placeholder='请在此输入信息("#"搜索快捷回复)'
                 @blur="showInput('2','allWorkOrder')" @input="inputChange" :class="{'editTextOne':isSecret}">
              </p>
              <p v-if="replyFlag" style="border: 1px solid #dae2fb;margin-top:10px;position: absolute;width: 55.5%;" id="replyDiv">
                <Table :columns="replyColumns" :data="replyData" :show-header="false" max-height="125" :stripe="false"
                no-data-text="没有快捷回复内容" @on-row-click="onRowClick"></Table>
              </p>
              <div style="float:right;margin-top:50px">
                <Button type="primary" @click="save()" :loading="loading">保存</Button>
              </div>
              <div style="float:right;margin-top:50px;max-width: 400px;max-height: 300px;overflow: auto">
                <Upload id="uploadTwo" :action="baseUploadUrl" :default-file-list="uploadList" show-upload-list
                        :on-remove="(file,fileList)=>removeFile(file,fileList)"></Upload>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="'edit' == addOrEdit" style="float:right;width:68%;box-shadow: 3px 3px 10px #9c9c9c;"
           :style="screenHeight">
        <div style="height: 100%">
          <div class="rightOneTop" style="height: auto" >
            <div style="height: 35px;display:flex;align-items: flex-start;justify-content: space-between;margin-bottom:2px">
              <div id="themeDiv" style="display:flex;align-items: center;">
                <p style="color:#f39c35;border:1px solid #f39c35;margin-right:25px;width: auto">
                  <Input id="themeInput" :style="inputWidth" style="text-align: center" v-model="orderTheme.popCustomValue"
                         :title="orderTheme.popCustomValue"
                         :placeholder="'输入工单'+orderTheme.customName" :disabled="editTable" @on-blur="editWorkOrder($event,orderTheme,0,0,'','','','allWorkOrder')"/>
                </p>
                <p style="margin-right:5px;"><img src="@/assets/image/workOrder/womesicon1.png"/></p>
                <p style="margin-right:10px;font-size: 14px;">#{{contentList.id}}</p>
                <p v-if="contentList.dictDescr && contentList.dictDescr.color"
                  style="background-color:#04c343;width:15px;height:15px;line-height:16px;text-align:center;color: white"
                  :style="{'background':contentList.dictDescr.color}">{{contentList.dictDescr.shortValue}}</p>
                <p v-if="contentList.dictDescr && contentList.dictDescr.color" style="color:#04c343;margin-right:10px;margin-left:5px;font-size: 14px;"
                   :style="{'color':contentList.dictDescr.color}">
                  {{contentList.orderState}}</p>
              </div>
              <div>
                <p v-show="contentList.orderState != '已删除'" v-if="roleList[orderDeleteFrom]"><img src="@/assets/image/workOrder/womesicon2.png" title="删除工单"
                        @click="deleteWorkOrder()"></p>
                <p v-show="contentList.orderState == '已删除'" v-if="roleList[orderRevertFrom]"><img src="@/assets/image/workOrder/revert.png" title="还原工单"
                                                                 @click="revertWorkOrder('allWorkOrder')"></p>
              </div>
            </div>
            <div style="height: 25px;display:flex;align-items: center;justify-content: flex-start;margin-bottom:1px">
              <p style="color:#9ea19f;margin-right:3px;display: flex;align-items: center;">
                <img src="@/assets/image/workOrder/timeOutRed.png" v-show="showSlaImg == '1'"/>
                <img src="@/assets/image/workOrder/timeOutGreen.png" v-show="showSlaImg == '2'"/>
              </p>
              <p style="color:#9ea19f;margin-right:10px;display: flex;align-items: center;" v-html="contentList.slaTime" :style="showColorForSla">
              </p>
              <p v-show="contentList.slaKpi" style="color:#fcfefd;background-color:#a0a0a0;margin-right:10px;padding:0px 5px">SLA指标</p>
              <p style="color:#9ea19f;margin-right:10px;">{{contentList.slaKpi}}</p>
            </div>
            <div style="height: 25px;display:flex;align-items: flex-start;justify-content: flex-start;margin-bottom:1px">
              <p style="color:#9ea19f;margin-right:5px;" title="创建时间">{{contentList.createTime}}</p>
              <p style="color:#9ea19f;margin-left:5px;">|</p>
              <p style="color:#9ea19f;margin-left:5px;margin-right:5px;" title="客户名称">{{contentList.customerName}}</p>
              <p><span>&lt;</span>
                <span><img src="@/assets/image/workOrder/womesicon3.png"/></span>
                <a href="javascript:void(0)" style="color:#2d8bef" @click="messageOrPhone(contentList.customerPhone)" title="手机号码">{{configInfo.phoneIsHide == '1'?contentList.customerPhoneHide:contentList.customerPhone}}</a>
                <span style="margin-left:5px;"></span>
                <span>&gt;</span>
              </p>
              <p v-show="contentList.serviceGroup" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
              <p v-show="contentList.serviceGroup" title="工单服务组" style="color:#9ea19f;">&lt;<span>{{contentList.serviceGroup}}</span>&gt;
              </p>
              <p v-show="contentList.orderHandler" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
              <p v-show="contentList.orderHandler" title="工单处理人" style="color:#9ea19f;">&lt;<span>{{contentList.orderHandler}}</span>&gt;
              </p>
            </div>
            <div class="replymo" v-if="showInputAndButton" style="height:130px;width:100%;position:relative;">
              <div style="height:30px;background-color:#eeeeee;width:100%;padding:5px 0 5px 15px;">
                <Checkbox v-model="isSecret" style="color:#a1a1a1;margin-right:20px">私密回复</Checkbox>
                <Poptip placement="top" transfer>
                  <img src="@/assets/image/workOrder/Expressicon.png"/>
                  <div slot="content">
                    <div v-for="(item, index) in emojiList" :key="index">
                      <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr"
                           @click="clickHandler(emotion)"/>
                    </div>
                  </div>
                  <span style="color: #a1a1a1;margin-right:20px;font-size:14px">表情</span>
                </Poptip>
                <Upload :action="baseUploadUrl" :on-error="uploadFail" :max-size="15360"
                        :before-upload="handleBeforeUpload" :on-success="(res,file)=>onSuccess(res,file)"
                        :on-exceeded-size="handleMaxSize" :show-upload-list="showUploadList"
                        style="display:inline-block">
                  <img src="@/assets/image/workOrder/Uploadicon.png"/>
                  <span style="color: #a1a1a1;font-size:14px">上传附件</span>
                </Upload>

              </div>
              <p class="edittext" contenteditable="true" ref="editDiv" :placeholder="placeHolderForInput"
                 style="height:100px;border: 1px solid #dae2fb;margin-top:0px;padding: 4px 7px;"
                 @blur="showInput('2','allWorkOrder')" @input="inputChange" :class="{'editTextOne':isSecret}"></p>
              <p v-if="replyFlag" style="border: 1px solid #dae2fb;margin-top:5px;position: absolute;width: 100%;z-index:100" id="replyDiv">
                <Table :columns="replyColumns" :data="replyData" :show-header="false" max-height="125" :stripe="false"
                no-data-text="没有快捷回复内容" @on-row-click="onRowClick"></Table>
              </p>
              <el-dropdown split-button type="primary" v-show="selectScene" @click="dropClick(selectScene,'allWorkOrder')"
                           style="width:150px;position:absolute;right:25px;bottom:-45px">
                {{selectScene}}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="sceneList && sceneList.length>0" v-for="(itemTwo,indexTwo) in sceneList" :key="indexTwo"
                                    @click.native="dropClick(itemTwo.label,'allWorkOrder')">{{ itemTwo.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div style="width: 68%;height: 50px;overflow: auto" v-if="showInputAndButton">
              <Upload id="uploadTwo" :action="baseUploadUrl" :default-file-list="uploadList" show-upload-list
                      :on-remove="(file,fileList)=>removeFile(file,fileList)"></Upload>
            </div>
            <div v-if="!showInputAndButton" style="width: 100%;height:50px;border-radius: 5px 5px 0 0;border: 1px solid #eff3f6;
            border-bottom: none;color: #8a6d3b;background-color: #fde4e4;display: flex;align-items: center;margin-bottom: 10px;">
              <span style="color: #8a6d3b;box-sizing: border-box;font-size: 15px;">{{showContent+contentList.orderTime}}</span>
            </div>
            <div v-if="showFinish || showReset" style="width: 100%;height: 50px;max-width: 50%;display: flex;align-items: center;margin-bottom: 10px;">
              <Button v-if="showFinish" type="info" style="margin-left: 10px" @click="auditAndReset('audit','allWorkOrder')">审核工单</Button>
              <Button v-if="showReset" type="info" style="margin-left: 10px" @click="auditAndReset('reset','allWorkOrder')">重置工单</Button>
            </div>
          </div>
          <div class="rightOneButtom"
               :style="rightHeightTwo">
            <div v-for="(option,indexFlow) in flowList" :key="indexFlow" style="margin-bottom: 20px;">
              <!-- 客户 -->
              <div v-if="!option.tip && '0' == option.isAgent"
                   style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                <div style="margin-right:10px">
                  <img src="@/assets/image/workOrder/wocus.png"/>
                </div>
                <div style="max-width: 90%;">
                  <div>
                    <p style="display:inline-block;color:#e49149">{{option.agentNumber}}</p>
                    <p style="display:inline-block;color:#e49149">{{option.msgTime}}</p>
                  </div>
                  <div>
                    <div style="float: left;max-width: 90%;" class="editTextThree">
                      <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                      <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                        <el-image v-if="item.type && item.type.indexOf('image') != -1"
                                  style="width: 100px; height: 100px" :src="baseImgURL + item.url"
                                  :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')"
                                  fit="contain"></el-image>
                        <div v-else
                             style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                          <p :title="item.name"
                             style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                            {{item.name}}</p>
                          <div style="width: 100%;font-size: 12px;height: 30px;">
                            <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                              <img style="width: 30px;height: 30px;" title="附件"
                                   src="@/assets/image/workOrder/download.png">
                            </div>
                            <div
                              style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                              <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                                 style="color: blue">下载</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 客服 -->
              <div @mousemove="showImg('1',option,indexFlow,'allWorkOrder')" @mouseleave="showImg('2',option,indexFlow,'allWorkOrder')"
                   v-if="!option.tip && '1' == option.isAgent"
                   style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                <div
                  style=" width:38px;height:38px; border-radius: 50%;position:relative;margin-right:10px;border:1px solid #1d82fe">
                  <img v-if="option.employeeHead"
                       style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                       :src="baseImgURL+option.employeeHead"/>
                  <img v-if="!option.employeeHead"
                       style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                       src="@/assets/image/customerService.png"/>
                </div>
                <div style="max-width: 90%;">
                  <div>
                    <p style="display:inline-block;color:#1d82fe">{{option.agentNumber}}</p>
                    <p style="display:inline-block;color:#1d82fe">{{option.msgTime}}</p>
                  </div>
                  <div style="float: left;max-width: 90%;" class="editTextFour">
                    <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                    <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                      <el-image v-if="item.type && item.type.indexOf('image') != -1" style="width: 100px; height: 100px"
                                :src="baseImgURL + item.url"
                                :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')" fit="contain"></el-image>
                      <div v-else
                           style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                        <p :title="item.name"
                           style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                          {{item.name}}</p>
                        <div style="width: 100%;font-size: 12px;height: 30px;">
                          <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                            <img style="width: 30px;height: 30px;" title="附件"
                                 src="@/assets/image/workOrder/download.png">
                          </div>
                          <div
                            style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                            <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                               style="color: blue">下载</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="width: 23px;height: 23px;float: left">
                    <img title="私密信息" src="@/assets/image/workOrder/lock.png" v-if="option.isSecret == '1'"
                         @click="changeSecret(option,indexFlow,'allWorkOrder')">
                    <img title="公开信息" src="@/assets/image/workOrder/unlock.png"
                         v-if="option.showImg && option.isSecret == '0'" @click="changeSecret(option,indexFlow,'allWorkOrder')">
                  </div>
                </div>
              </div>
              <!--tip提示-->
              <div v-if="option.tip" style="display:flex;align-items: center;justify-content: center;">
                <p style="color:#7d7d7c" v-html="option.tip"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="clear:both"></div>
    </div>
    <el-dialog
      title="追加回复"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="50%">
      <Spin size="large" fix v-if="spinShowForDialog">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>
      <Input v-model="contentForReply" :placeholder="contentForPlace" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
      <Checkbox v-model="isSecretForReply" class="order_class" >私密回复</Checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveChange('allWorkOrder')">提交回复</el-button>
        <el-button @click="cancelChange">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog id="dialog_delete"
      title="请选择删除工单的理由"
      :visible.sync="dialogForDelete"
      width="30%">
      <el-radio-group style="padding-bottom: 10px;" v-model="radioForDelete">
        <el-radio label="无效信息">无效信息</el-radio>
        <el-radio label="重复信息">重复信息</el-radio>
        <el-radio label="恶意骚扰">恶意骚扰</el-radio>
        <el-radio label="其他原因">其他原因</el-radio>
      </el-radio-group>
      <Input v-show="radioForDelete == '其他原因'" v-model="contentForDelete" placeholder="请输入详情原因" type="textarea" :autosize="{minRows: 3,maxRows: 100}"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doDelete">确定</el-button>
      </span>
    </el-dialog>
    <searchCustomerInfoPop @closeCustomerInfo="closeCustomerInfoOnly"
                           :showCustomerInfo="showCustomerInfo"></searchCustomerInfoPop>
    <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
    <AuditAndResetPop  @closeHandlerPop="closeHandlerPop" fromWhere="allWorkOrder" :orderFromWhere="orderFromWhere" :workOrderId="workOrderId" :showHandlerPop="showHandlerPop"  :actionForHandler="actionForHandler" ></AuditAndResetPop>
  </div>
</template>
<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {workOrderPublic} from '@/components/js/WorkOrderPublic.js'
  import searchCustomerInfoPop from '@/components/customerMange/SearchCustomerInfoPop.vue'
  import File from '@/components/customerMange/File.vue'
  import eventBus from "../../util/eventBus";
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  import AuditAndResetPop from '@/components/workOrder/AuditAndResetPop.vue';

  export default {
    name: "NewWorkOrder",
    mixins: [publicFunClass,workOrderPublic],
    components: {
      AuditAndResetPop,
      searchCustomerInfoPop,
      File,
      publicDialerPage,
      PublicSendMessage
    },
    props: {
      addWorkOrderFlag: String,
      workReserve: Array,
      orderId: String,
      pageCode: String,
    },
    data() {
      return {
        isShowImg: false,
        name: '',
        screenHeight: {height: ''},
        rightHeight: {height: ''},
        rightHeightTwo: {height: ''},
        heightStyle: {'height': '', 'overflow-y': 'hidden', 'overflow-x': 'hidden'},
        showUploadList: false,
        fileData: [],
        ruleValidate: {},
        customerId: '',
        journalType: '',
        menuId: '',
        oldTelFull: '',
        isSecret: false,
        addOrEdit: "",
        workOrderId: '',
        sceneList: [],
        selectScene: '',
        flowList: [],
        inputWidth: {'width': ''},
        uploadList: [],
        fileType: '',
        pageUuId: '',
        showPreInput: '',
        workOrderState:'',
        orderStateItem: {},
        showInputAndButton:true,
        dictOrderStateId:'',
        showSlaImg:'',
        editTable:false,
        editHandle:false,
        editCopyId:false,
        orderFromWhere:'',
        orderDeleteFrom:'',
        orderRevertFrom:'',
        handlerList:{},

        replyFlag:false,  //快捷回复显示标识
        replyColumns: [ { title: 'replyWord', key: 'replyWord', maxWidth:200,ellipsis:true }, { title: 'replyContent', key: 'replyContent',ellipsis:true } ],
        replyData: [],
        textFlag:false, //中文输入还是英文输入的标识
      }
    },
    methods: {
      bindEvents:function () {
        let that = this
        eventBus.$on('findWorkOrderIsOpen', function (workOrderId) {
          if(workOrderId == that.workOrderId){
            that.initWorkOrder('allWorkOrder');
          }
        });
        eventBus.$on('workOrderIsDelete', function (workOrderId) {
          if(workOrderId == that.workOrderId){
            that.$Message.info("工单已被删除");
            that.$emit("closeFlowEdit", that.pageCode);
          }
        });
      },
      save: function () {
        let uploadList = "";
        if (this.uploadList && this.uploadList.length > 0) {
          uploadList = JSON.stringify(this.uploadList);
        }
        let that = this;
        this.spinShow = true;
        let param = {
          journalType: "工单管理=>添加工单",
          menuId: 'b_2-1',
          customerId: this.customerId,
          fileAddr: uploadList,
          isSecret: this.isSecret ? "1" : "0"
        };
        let newHtml = this.$refs.editDiv.innerHTML;
        let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
          .replace(/<\/?.+?\/?>/g, ''); //替换html标签
        let newStr = str.replace(/[ ]|[\r\n]/g, "").replace(/&nbsp;/g,"");
        let phoneIsHide = that.configInfo.phoneIsHide;
        for (let j = 0; j < this.fileData.length; j++) {
          let allColumnInfo = this.fileData[j].allColumnInfo;
          for (let i = 0; i < allColumnInfo.length; i++) {
            let popCustomValue = allColumnInfo[i].popCustomValue;
            let customColName = allColumnInfo[i].customColName;
            let type = allColumnInfo[i].type;
            if (!popCustomValue || popCustomValue.length == 0) {
              popCustomValue = "";
            }
            if ((type == "cascade" || type == "checkbox") && popCustomValue.length > 0) {
              popCustomValue = popCustomValue.toString();
            }
            if (type == "datetime" && popCustomValue) {
              popCustomValue = this.timeChange(popCustomValue);
            }
            if (type == "file" && popCustomValue) {
              // 如果下载地址是空的，保存时去除这行数据
              let fileJson = JSON.parse(popCustomValue);
              let newFlag = 0;
              for (let n = 0; n < fileJson.length;) {
                newFlag++;
                if (!fileJson[n].downloadAddr) {
                  fileJson.splice(n, 1);
                } else if (!fileJson[n].description) {
                  let customName = allColumnInfo[i].customName;
                  that.$Modal.info({
                    title: '提示',
                    content: "" + customName + "的第" + newFlag + "个附件已上传成功，但对应备注为空，请确认后重试"
                  });
                  this.spinShow = false;
                  return false;
                } else {
                  n++;
                }
              }
              popCustomValue = JSON.stringify(fileJson);
            }
            if (customColName.indexOf("customerPhone") != -1) {
              if (phoneIsHide == '1' && this.oldTelHide == popCustomValue) {
                popCustomValue = this.oldTelFull;
              }
            }
            if (customColName.indexOf("orderDescribe") != -1) {
              popCustomValue = newStr;
            }
            if (customColName.indexOf("orderTheme") != -1) {
              popCustomValue = this.orderTheme.popCustomValue;
            }

            param[allColumnInfo[i].customColName] = popCustomValue;
          }
        }
        let url = "workOrder/doSave.json";
        this.loading = true;
        this.$http.post(url, param).then(function (res) {
          let result = res.data.flag;
          that.loading=false;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            that.spinShow = false;
            return false;
          }
          that.$Modal.info({
            title: '提示',
            content: "操作成功"
          });

          let orderId = res.data.obj;
          if (orderId) {
            that.workOrderId = orderId;
          }
          let name = that.orderTheme.popCustomValue;
          name = name.replace(/<[^>]+>/g, "");
          if (name && name.length > 5) {
            name = name.substring(0, 5) + "…";
          }
          that.$refs.editDiv.innerHTML = "";
          that.showPreInput = '';
          that.$emit("updateWorkOrderTabName", name, orderId, that.addWorkOrderFlag.split(",")[0]);
          that.addOrEdit = "edit";
          that.initWorkOrder('allWorkOrder');
          that.spinShow = false;
        });
      },
      closeCustomerInfoOnly:function(flag, selection){
        this.closeCustomerInfo(flag, selection, 'allWorkOrder');
      },
      // 上传文件过程中不能保存，调用的接口
          fileUploadCallback(flag){
            if(flag || flag == 'true'){
              this.loading = true;
            }else{
              this.loading = false;
            }
          }
    },
    created() {
      this.screenHeight.height = this.mountHeight(112);
      this.heightStyle.height = this.mountHeight(180);
    },
    destroyed() {
      eventBus.$off('findWorkOrderIsOpen');
      eventBus.$off('workOrderIsDelete');
    },
    mounted() {
      this.$nextTick(() => {
        this.bindEvents();
      })
    },
    updated() {
      this.$nextTick(() => {
        this.clientScreenHeight();
      })
    },
    watch: {
      addWorkOrderFlag: function (obj) {
        this.showPreInput = "";
        let newObj = obj.split(",");
        let reserve = this.$store.getters.getWorkOrderReserve(newObj[0]);
        let paramData = this.$store.getters.getWorkOrderData(newObj[0]);
        this.orderFromWhere = '';
        if(newObj.length > 3 && newObj[2]){
          this.orderFromWhere = newObj[2];
        }
        this.orderDeleteFrom = "";
        this.orderRevertFrom = "";
        if(this.orderFromWhere){
          let newValue = this.orderFromWhere.substring(0,3);
          this.orderDeleteFrom = newValue;
          if('b_2' == this.orderDeleteFrom){
            this.orderDeleteFrom += '-6';
          }else if('b_d' == this.orderDeleteFrom){
            this.orderRevertFrom = 'b_d-1';
            this.orderDeleteFrom = '';
          }else{
            this.orderDeleteFrom += '-2';
          }
        }
        let fileData = [];
        let code = "";
        if(reserve){
          fileData = reserve.objData;
          code = reserve.pageUuId;
          this.pageUuId = code;
        }
        this.workOrderId = this.orderId;
        if (this.orderId || (paramData && paramData.workId)) {
          this.addOrEdit = "edit";
          //判断是否为编辑页面
          if (!paramData || !paramData.contentList) {
            //没有数据重新查询
            this.initWorkOrder('allWorkOrder');
          } else {
            //有数据直接更新
            this.fileData = paramData.fileData;
            this.contentList = paramData.contentList;
            this.flowList = paramData.flowList;
            this.uploadList = paramData.uploadList;
            this.pageUuId = paramData.pageUuId;
            this.orderTheme = paramData.orderTheme;
            this.orderDescribe = paramData.orderDescribe;
            this.isSecret = paramData.isSecret;
            this.showPreInput = paramData.showPreInput;
            this.initWorkOrder('allWorkOrder');
          }
        } else {
          //添加页面
          this.addOrEdit = "add";
          this.fileData = fileData;
          //判断是否首次进入，首次进入需要重新排列数据列
          if (paramData && paramData.fileData) {
            this.fileData = paramData.fileData;
            this.contentList = paramData.contentList;
            this.flowList = paramData.flowList;
            this.uploadList = paramData.uploadList;
            this.pageUuId = paramData.pageUuId;
            this.orderTheme = paramData.orderTheme;
            this.orderDescribe = paramData.orderDescribe;
            this.isSecret = paramData.isSecret;
            this.showPreInput = paramData.showPreInput;
          } else {
            //重新排列数据列，刷新数据
            this.isSecret = false;
            this.initWorkOrder('allWorkOrder');
          }
        }
        this.$nextTick(() => {
          let newString = "";
          if (this.showPreInput) {
            newString = this.showPreInput
          }
          if (this.$refs.editDiv) {
            this.$refs.editDiv.innerHTML = newString;
          }
        })
        this.$forceUpdate();
      },
    }

  }
</script>

<style scoped>
  #addOrEdit /deep/ .ivu-form-item {
    margin-bottom: 0px;
  }

  #addOrEdit /deep/ .ivu-form-item-error .ivu-select-arrow {
    color: #808695;
  }

  #addOrEdit /deep/ .ivu-date-picker {
    display: block;
  }

  #addOrEdit /deep/ .el-cascader {
    display: block;
  }

  #addOrEdit /deep/ .ivu-form-item-error .ivu-select-selection {
    border: 1px solid #57a3f3;
    box-shadow: none;
  }

  #addOrEdit /deep/ .ivu-form-item-error .ivu-input {
    border: 1px solid #57a3f3;
    box-shadow: none;
  }

  .formDefinedClass {
    width: 100% !important;
  }

  .formDefinedClass /deep/ .ivu-form-item-content {
    width: 100% !important;
  }

  .formDefinedClass /deep/ .ivu-input-type-textarea {
    height: auto !important;
  }

  #themeDiv /deep/ .ivu-input {
    border: 0;
    box-shadow: none;
    color: rgb(243, 156, 53);
  }

  #uploadTwo /deep/ .ivu-upload-select {
    display: none;
  }

  .editTextOne {
    background-color: ivory;
  }

  .editTextThree {
    padding: 6px;
    border: rgb(246, 186, 119) 1px solid;
    border-radius: 10px;
    background-color: rgb(246, 186, 119);
  }

  .editTextFour {
    padding: 6px;
    border: #cce4fc 1px solid;
    border-radius: 10px;
    background-color: #cce4fc;
  }
  .edittext:empty::before {
    color: lightgrey;
    content: attr(placeholder);
  }
  .rightOneTop{
    padding-top:20px;
    padding-left:5%;
    padding-right:5%;
  }
  .rightOneButtom{
    padding-left:5%;
    padding-right:5%;
    overflow-y: auto;
    background-color: rgb(250,251,253);
  }

  #addOrEdit /deep/ .el-select{
    width: 100%;
    box-sizing: border-box;
    vertical-align: middle;
    color: #515a6e;
    font-size: 14px;
    line-height: normal;
  }
  #addOrEdit /deep/ .el-input--suffix .el-input__inner{
    height: 32px;
  }
  #addOrEdit /deep/ .el-input__icon{
    line-height: 32px;
  }
  #themeInput /deep/ .ivu-input{
    text-align: center;
  }
   #replyDiv /deep/ .ivu-table td{
    border-bottom:0px !important;
    height:25px !important;
  }
 #replyDiv /deep/  .ivu-table-wrapper {
    position: unset !important;
}
  #dialog_delete /deep/ .el-dialog__title{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/workOrder/NewWorkOrder.vue